
import { TransportationDetails } from '@/types/itinerary';
import { format } from 'date-fns';

/**
 * Get readable transportation type name
 */
export const getTypeDisplayName = (type: string): string => {
  switch (type) {
    case 'flight': return 'Flight';
    case 'train': return 'Train';
    case 'car': return 'Car';
    case 'shuttle': return 'Shuttle';
    case 'ferry': return 'Ferry/Ship';
    default: return type || 'Transportation';
  }
};

/**
 * Format confirmations for description
 */
export const formatConfirmations = (details: TransportationDetails): string => {
  if (details.confirmations && details.confirmations.length > 0) {
    return `Confirmation(s): ${details.confirmations.map(c => c.value).join(', ')}`;
  }
  return details.confirmation ? `Confirmation: ${details.confirmation}` : '';
};

/**
 * Build event description from transportation details
 */
export const buildEventDescription = (details: TransportationDetails): string => {
  const typeDisplay = getTypeDisplayName(details.type);
  
  // Build description with all details
  let description = `Type: ${typeDisplay}\n`;
  
  if (details.flightNumber) {
    description += `Flight Number: ${details.flightNumber}\n`;
  }
  
  const confirmationText = formatConfirmations(details);
  if (confirmationText) {
    description += `${confirmationText}\n`;
  }
  
  if (details.notes) {
    description += details.notes;
  }
  
  return description;
};

/**
 * Create initial transportation state
 */
export const getInitialTransportationState = (): TransportationDetails => ({
  type: '',
  departure: '',
  arrival: '',
  departureDate: null,
  departureTime: '',
  notes: '',
  confirmation: '',
  userName: '',
  flightNumber: '',
  confirmations: []
});
